var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdificio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.4 151.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.77,
    width: 66.86,
    height: 151.97,
    style: {
      fill: "#e6e8f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.8,114.26c.56-1.7.62-3.52.18-5.25-.84-3.31-3.45-5.89-6.78-6.69-5-1.23-10.04,1.83-11.27,6.82-.18.73-.27,1.47-.27,2.22,0,.82.11,1.64.32,2.43,1.04,3.46.65,7.19-1.09,10.35-3.21,5.56-1.3,12.67,4.25,15.88,5.56,3.21,12.67,1.3,15.88-4.25,2.01-3.48,2.08-7.74.19-11.28-1.86-3.07-2.37-6.77-1.42-10.23h0Z",
    style: {
      fill: "#80aa38"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.64,
    y: 111.36,
    width: 4.65,
    height: 40.61,
    style: {
      fill: "#79982b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.93,114.26c.56-1.7.62-3.52.18-5.25-.84-3.31-3.45-5.89-6.78-6.69-5-1.23-10.04,1.83-11.27,6.82-.18.73-.27,1.47-.27,2.22,0,.82.11,1.64.32,2.43,1.04,3.46.65,7.19-1.09,10.35-3.21,5.56-1.3,12.67,4.25,15.88,5.56,3.21,12.67,1.3,15.88-4.25,2.01-3.48,2.08-7.74.19-11.28-1.86-3.07-2.37-6.77-1.42-10.23h0Z",
    style: {
      fill: "#80aa38"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.77,
    y: 111.36,
    width: 4.65,
    height: 40.61,
    style: {
      fill: "#79982b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 27.16,
    y: 53.75,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.42,
    y: 53.75,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.68,
    y: 53.75,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.16,
    y: 76.16,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.42,
    y: 76.16,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.68,
    y: 76.16,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.16,
    y: 98.56,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.42,
    y: 98.56,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.68,
    y: 98.56,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.16,
    y: 8.94,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.42,
    y: 8.94,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.68,
    y: 8.94,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.16,
    y: 31.35,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.42,
    y: 31.35,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.68,
    y: 31.35,
    width: 9.56,
    height: 14.4,
    style: {
      fill: "#8386c0"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 33.82,
    y: 124.72,
    width: 16.05,
    height: 23.83,
    style: {
      fill: "#d4d7ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.19,
    y: 124.72,
    width: 16.05,
    height: 23.83,
    style: {
      fill: "#d4d7ed"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.73,
    y: 121.58,
    width: 44.93,
    height: 3.14,
    rx: 0.76,
    ry: 0.76,
    style: {
      fill: "#8386c0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 148.56,
    width: 102.4,
    height: 3.41,
    style: {
      fill: "#d4d7ed"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdificio);
export default __webpack_public_path__ + "static/media/edificio.5658b606a0cd91be691708ba334f468d.svg";
export { ForwardRef as ReactComponent };